import { jsx as _jsx } from "react/jsx-runtime";
/**
 * StyxDesk brand mark — wordmark/logo image that swaps with the active theme.
 *
 *   Light mode → /logo.png            (dark text on light background)
 *   Dark  mode → /logo-dark-bg.png    (white text on dark background)
 *
 * The image is served from /public so it's a plain absolute URL; no Vite
 * import needed and no bundle weight per page chunk.
 *
 * Two visual sizes:
 *   <BrandMark variant="compact" />  — sidebar header (h-8)
 *   <BrandMark variant="hero"    />  — login splash    (h-12)
 */
import { useTheme } from '@/store/theme';
export function BrandMark({ variant = 'compact', className, onDark = false }) {
    const { resolvedTheme } = useTheme();
    const src = onDark || resolvedTheme === 'dark' ? '/logo-dark-bg.png' : '/logo.png';
    // Sized to fit the parent rather than driven by intrinsic dimensions, so
    // a tall vs square logo file substitution doesn't break layout.
    const sizing = variant === 'hero' ? 'h-12' : 'h-8';
    return (_jsx("img", { src: src, alt: "StyxDesk", 
        // `shrink-0` + an explicit `w-auto` keep the natural aspect ratio: in a
        // flex column the default `align-items: stretch` would otherwise widen
        // the image to the container, distorting it. (The sidebar header also
        // sets `items-start`; this is belt-and-suspenders for any other parent.)
        className: [sizing, 'w-auto shrink-0 select-none', className ?? ''].join(' '), 
        // Prevent the browser flickering between the two sources during the
        // theme swap — modern browsers preload all `srcset` entries.
        // We don't use srcset here because the swap is theme-driven, not
        // viewport-driven; the second key is just a fallback for noscript.
        draggable: false }));
}
